




































import Vue from 'vue'
import i18n from '@/i18n'
export default Vue.extend({
  name: 'ModalWrapper',
  props: {
    title: String,
    message: String,
    resolve: Function,
    buttonLabel: {
      type: String,
      default: i18n.t('actions.accept')
    },
    buttons: Array
  },
  data () {
    return {
      show: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.show = true
    })
    window.addEventListener('keydown', this.handleEscape)
  },
  destroyed () {
    window.removeEventListener('keydown', this.handleEscape)
  },
  methods: {
    close () {
      this.actionHandler('close')()
    },
    buttonHandler (eventName: string) {
      this.actionHandler(eventName)()
    },
    handleEscape (event: KeyboardEvent) {
      if (event.key === 'Escape') {
        this.close()
      }
    },
    actionHandler (action: string) {
      return (data?: any) => {
        this.resolve({ action, data })
        this.show = false
      }
    }
  }
})
